import React from "react";
import MaskedInput from "react-text-mask";

const CBUInput = React.forwardRef(function CBUInput(props, ref) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(maskedRef) => {
        const input = maskedRef ? maskedRef.inputElement : null;

        // ref que viene de MUI
        if (ref) {
          if (typeof ref === "function") {
            ref(input);
          } else {
            ref.current = input;
          }
        }

        // inputRef opcional (por compatibilidad)
        if (inputRef) {
          if (typeof inputRef === "function") {
            inputRef(input);
          } else {
            inputRef.current = input;
          }
        }
      }}
      mask={(rawValue = "") => {
        rawValue.replace(/\s/g, "");

        return [
          /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
          /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
          /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,
          /\d/, /\d/, /\d/, /\d/,
        ];
      }}
      placeholderChar={"\u2000"}
    />
  );
});

export default CBUInput;
